module.exports = __webpack_public_path__ + "static/media/image.458ecb68.png";